module.exports = __webpack_public_path__ + "fonts/iconfont.ec09c06.ttf";